import React, {useState } from 'react'
import "./BySlotTime.css"
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../Navbar/Navbar';
import Stepper from '../Stepper/Stepper';
import {slotData} from "../../../../Data"
import { useDispatch } from 'react-redux';
import { partBookingDetails } from '../../../../Redux/Slice/AuthSlice';

const BySlotTime = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation();
  const partydate = location.state
  console.log(partydate)
  const handleTime = (data)=>{
    let partyDate = {partytime:data,partydate}
    dispatch(partBookingDetails(JSON.stringify({data:partyDate,message:'dateTime'})))
    navigate('/portal/booking/party/party-booking-03-package',{state:partyDate})
  }
    
  return (
    <div className="kiga-portal-slotTime-main">
     <Navbar />
     <div className="kiga-portal-slotTime-head-title">
      <p>Party Booking</p>
     </div>
     <Stepper/>
     <section className='kiga-portal-slotTime-section'>
      <div className='kiga-portal-slotTime-section-title'>
        <h5>step 2</h5>
        <p>Choose a Time Slot</p>
      </div>
       <div className='kiga-portal-slotTime-section-card'>
        <div className='kiga-portal-slotTime-section-card-content-image'>
        <div className='kiga-portal-slotTime-section-card-image'>
          <img src='/images/Gallery/holiday.jpg' alt='slot-pc'/>
         </div>
        </div>
         <div className='kiga-portal-slotTime-section-card-content'>
          <div className='kiga-portal-slotTime-section-card-content-title'>
            <p>The Whole Gymnasium</p>
          </div>
          <div className='kiga-portal-slotTime-section-card-content-info'>
            <p>Use all equipment in the gymnasium for your party. Please note other classes will be ongoing at the same time.</p>
          </div>
          <div className='kiga-portal-slotTime-section-card-content-time'>
            {
           slotData?.map((el,index)=>(
            <div className='kiga-portal-slotTime-section-card-content-time-box' key={index}>
              <button onClick={()=>handleTime(el?.time)}>
                 {
                  el?.time
                 }
              </button>
            </div>
              ))
            }
          </div>
         </div>
       </div>
     </section>
    </div>
  )
}

export default BySlotTime